module.exports = __webpack_public_path__ + "media/images/icons/pin-8722da2f55b64f79de134c51be322439.svg";